import { render, staticRenderFns } from "./TaskSidebar.vue?vue&type=template&id=4423258d&scoped=true"
import script from "./TaskSidebar.vue?vue&type=script&lang=js"
export * from "./TaskSidebar.vue?vue&type=script&lang=js"
import style0 from "./TaskSidebar.vue?vue&type=style&index=0&id=4423258d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423258d",
  null
  
)

export default component.exports